import { hexToU8a } from "@polkadot/util";
import {
  encodeAddress,
  decodeAddress,
  blake2AsU8a,
} from "@polkadot/util-crypto";
export function formatThousands(value: number | string, point = 2): string {
  // 尝试将字符串转换为数字
  const num =
    typeof value === "number" ? value : parseFloat(value.replace(/,/g, ""));

  // 如果是 NaN，直接返回原始字符串
  if (isNaN(num)) return String(value);

  // 判断是否为整数
  return num.toLocaleString(undefined, {
    minimumFractionDigits: point,
    maximumFractionDigits: point,
  }); // 保留两位小数
}

export function toChainAmountDecimal(
  value: string | number,
  decimals: number = 9
): bigint {
  if (typeof value === "number") {
    value = value.toString();
  }

  const [intPart, decPart = ""] = value.split(".");

  const paddedDecimals = (decPart + "0".repeat(decimals)).slice(0, decimals);
  const normalized = intPart + paddedDecimals;

  // 防止空字符串或非数字
  if (!/^\d+$/.test(normalized)) {
    throw new Error(`Invalid input: ${value}`);
  }

  return BigInt(normalized);
}

export function formatDecimal(val: unknown, decimals = 4): number {
  if (val === undefined || val === null) return 0;
  const num = Number(val);
  if (Number.isNaN(num)) return 0;
  return (
    Number(
      (Math.trunc(num * 10 ** decimals) / 10 ** decimals).toFixed(decimals)
    ) || 0
  );
}

export function convertH160ToSS58(ethAddress: string) {
  const prefix = "evm:";
  const prefixBytes = new TextEncoder().encode(prefix);
  const addressBytes = hexToU8a(
    ethAddress.startsWith("0x") ? ethAddress : `0x${ethAddress}`
  );
  const combined = new Uint8Array(prefixBytes.length + addressBytes.length);

  // Concatenate prefix and Ethereum address
  combined.set(prefixBytes);
  combined.set(addressBytes, prefixBytes.length);

  // Hash the combined data (the public key)
  const hash = blake2AsU8a(combined);

  // Convert the hash to SS58 format
  const ss58Address = encodeAddress(hash, 42); // Assuming network ID 42, change as per your network
  return ss58Address;
}
